import React from 'react';
import { useTranslation } from 'react-i18next';
import { SearchParam } from '../../../core/routing/param';
import { useSearchParam } from '../../../core/routing/hooks/use-search-param';
import { FormType } from '../../backend/openapi/api-types';
import { AuthenticatedForm } from './authenticated-form';

export const OrderSampleSheet: React.FC = () => {
  const { t } = useTranslation();
  const params = useSearchParam([SearchParam.articleId, SearchParam.storedAddressId]);

  return (
    <AuthenticatedForm
      documentTitle={t('form.orderSampleSheet.documentTitle')}
      formType={FormType.orderSampleSheet}
      hintText={t('form.orderSampleSheet.hintText')}
      queryParam={params}
    />
  );
};
